module.exports = __webpack_public_path__ + "media/images/recruit/entry/icon-check-3bbe7e65bed0ae7455730ae4b7a3a75f.svg";